import { Button, Result } from "antd";
import { FaBan } from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";

const BlockPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const contactInfo = searchParams.get("Contact");
  const defaultSubtitle =
    "The requested site is currently blocked by your network or administrator. This could be due to security policies, content filtering, or temporary restrictions.";

  // Handle \n or \\n as actual newlines
const formattedSubtitle = contactInfo
  ? contactInfo.split("\n").map((line, idx) => <div key={idx}>{line}</div>)
  : defaultSubtitle;

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <Result
        status="error"
        icon={
          <div className="flex justify-center">
            <FaBan className="text-red-500 text-6xl" />
          </div>
        }
        title="Site is blocked"
        subTitle={formattedSubtitle}
        extra={[
          <Button type="primary" key="back" onClick={() => navigate(-1)}>
            Go Back
          </Button>,
        ]}
      />
    </div>
  );
};

export default BlockPage;
